module.exports = __webpack_public_path__ + "img/idea-score.3384bf5a.svg";